/**
 * Shared component for displaying athlete assignment info (Coach, Team, Manager)
 * Used by AthleteCard and AllAthletesManager to ensure consistency
 */
import { Users, Activity, User, Shield } from 'lucide-react';

export default function AthleteInfoDisplay({ 
  coachName, 
  teamName, 
  managerName,
  compact = false,
  className = ''
}) {
  if (!coachName && !teamName && !managerName) {
    return null;
  }

  if (compact) {
    // Inline format for list views
    return (
      <div className={`flex items-center gap-3 text-xs flex-wrap ${className}`}>
        {coachName && (
          <span className="text-[#02b5ff]">
            Coach: {coachName}
          </span>
        )}
        {teamName && (
          <span className="text-emerald-400">
            Team: {teamName}
          </span>
        )}
        {managerName && (
          <span className="text-purple-400">
            Manager: {managerName}
          </span>
        )}
      </div>
    );
  }

  // Stacked format for card views - Order: Coach, Manager, Team
  return (
    <div className={`space-y-1 ${className}`}>
      {coachName && (
        <p className="text-xs text-[#02b5ff] flex items-center">
          <Users className="h-3 w-3 mr-1" />
          Coach: {coachName}
        </p>
      )}
      {managerName && (
        <p className="text-xs text-purple-400 flex items-center">
          <User className="h-3 w-3 mr-1" />
          Manager: {managerName}
        </p>
      )}
      {teamName && (
        <p className="text-xs text-emerald-400 flex items-center">
          <Shield className="h-3 w-3 mr-1" />
          Team: {teamName}
        </p>
      )}
    </div>
  );
}
